import { combineReducers } from 'redux';
export const SetTitle = 'Set_Title';



export const ActionTitle = {
    setTitle: (title: string) => ({
        type: SetTitle,
        payload: title,
    }),

};

const Title = (state: string = "", action: any) => {

    switch (action.type) {
        case SetTitle:
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export const gettitle = (state: any) => state.Title;

export default combineReducers({
    Title
});
